import { createTheme, responsiveFontSizes } from "@mui/material";
import { customColors } from "models/customColors";

export const theme = responsiveFontSizes(
  createTheme({
    shape: {
      borderRadius: 6,
    },
    typography: {
      fontFamily: ["sans-serif"].join(","),
    },
    palette: {
      primary: {
        main: customColors.mainColor,
      },
      warning: {
        main: customColors.warningColor,
      },
      text: {
        primary: customColors.text,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            textTransform: "none",
            padding: "10px 60px",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: "1rem",
            gap: "20px",
            maxHeight: "calc(100% - 20px)",
            maxWidth: "unset",
          },
        },
      },

      MuiDialogTitle: {
        styleOverrides: {
          root: {
            fontWeight: "500",
            textAlign: "center",
            padding: "25px 40px 15px 40px",
            fontSize: "26px",
            color: customColors.black,
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            backgroundColor: customColors.header.grayBack,
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            textAlign: "center",
            fontSize: "1.1rem",
            padding: "0 40px",
            color: customColors.grayText,
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              // "& fieldset": {
              //   borderColor: "transparent",
              // },
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            borderRadius: "6px",
            backgroundColor: customColors.header.grayBack,
            borderColor: "transparent",
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            color: customColors.text,
          },
        },
      },
    },
  })
);
